import { useQuery } from "@apollo/client";
import _ from "lodash";
import { ReactElement } from "react";
import { useParams } from "react-router-dom";

import {
  GetCampaignForTexterQuery,
  GetCampaignForTexterQueryVariables,
  GetInboxQuery,
  GetInboxQueryVariables,
} from "~frontend/__generated__/graphql";
import ErrorCard from "~frontend/components/ErrorCard";
import Loading from "~frontend/components/Loading";
import { GET_CAMPAIGN_FOR_TEXTER } from "~frontend/graphql/campaigns";
import { GET_INBOX } from "~frontend/graphql/inboxes";
import { useIntl } from "~frontend/providers/IntlProvider";

import { InboxAssignments } from "./InboxAssignments";

export function InboxCampaign(): ReactElement {
  const { inboxId: maybeInboxId, campaignId: maybeCampaignId } = useParams<{
    inboxId: string;
    campaignId: string;
  }>();
  const intl = useIntl();
  const inboxId = maybeInboxId!;
  const routeIsNoCampaign = maybeCampaignId === "no_campaign";
  const campaignId = routeIsNoCampaign ? null : maybeCampaignId!;

  const getInboxResponse = useQuery<GetInboxQuery, GetInboxQueryVariables>(
    GET_INBOX,
    { variables: { input: { inboxId } }, pollInterval: 60 * 1000 }
  );

  const getCampaignResponse = useQuery<
    GetCampaignForTexterQuery,
    GetCampaignForTexterQueryVariables
  >(GET_CAMPAIGN_FOR_TEXTER, {
    variables: { input: { campaignId: campaignId! } },
    skip: !campaignId,
  });
  if (getInboxResponse.loading || getCampaignResponse?.loading) {
    return <Loading />;
  }

  if (getInboxResponse.error) {
    return <ErrorCard errors={[getInboxResponse.error]} />;
  }

  if (getCampaignResponse?.error) {
    return <ErrorCard errors={[getCampaignResponse.error]} />;
  }

  const inbox = getInboxResponse.data!.getInbox;

  if (inbox.__typename === "CampaignInboxSummary") {
    return <ErrorCard errors={["Invalid link"]} />;
  }

  return (
    <InboxAssignments
      inbox={inbox}
      campaignId={campaignId}
      refetchInbox={getInboxResponse.refetch}
      headerText={
        routeIsNoCampaign
          ? intl.formatMessage({
              defaultMessage: "No associated campaign",
              description: "Label for a thread without an owning campaign",
            })
          : undefined
      }
    />
  );
}
